<template>
  <VProgressCircular indeterminate :size="size" class="ui-progress-circular" />
</template>

<script setup lang="ts">
import { VProgressCircular } from 'vuetify/components/VProgressCircular';

interface Props {
  size?: number;
}

withDefaults(defineProps<Props>(), {
  size: 24,
});
</script>

<style lang="scss" scoped>
@keyframes progress-circular-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 100, 200;
    stroke-dashoffset: -15px;
  }
  100% {
    stroke-dasharray: 100, 200;
    stroke-dashoffset: -124px;
  }
}

.ui-progress-circular {
  :deep(.v-progress-circular__overlay) {
    animation: progress-circular-dash 1.4s ease-in-out infinite;
    transform: initial;
    stroke: rgb(var(--v-theme-primary));
  }

  :deep(.v-progress-circular__underlay) {
    stroke: rgb(var(--v-theme-white));
  }
}
</style>
